import React, { useMemo, useState } from "react";
import {
    FileText,
    Download,
    Users,
    UserPlus,
    CreditCard,
    Wallet,
    ShieldCheck,
    TrendingUp,
    CalendarDays,
    Filter,
    ChevronDown,
} from "lucide-react";

const memberRegistrationData = [
    { month: "Apr", registrations: 42 },
    { month: "May", registrations: 58 },
    { month: "Jun", registrations: 51 },
    { month: "Jul", registrations: 73 },
    { month: "Aug", registrations: 65 },
    { month: "Sep", registrations: 84 },
];

const subscriptionData = [
    {
        plan: "Basic",
        members: 95,
        revenue: 95000,
        percentage: 34,
    },
    {
        plan: "Premium",
        members: 120,
        revenue: 180000,
        percentage: 43,
    },
    {
        plan: "Gold",
        members: 70,
        revenue: 210000,
        percentage: 23,
    },
];

const paymentData = [
    {
        method: "UPI",
        transactions: 142,
        amount: 185000,
    },
    {
        method: "Bank Transfer",
        transactions: 38,
        amount: 125000,
    },
    {
        method: "Credit Card",
        transactions: 26,
        amount: 85000,
    },
    {
        method: "Debit Card",
        transactions: 19,
        amount: 52000,
    },
];

const verificationData = [
    {
        status: "Verified",
        count: 285,
    },
    {
        status: "Pending",
        count: 48,
    },
    {
        status: "Rejected",
        count: 12,
    },
];

const performanceData = [
    {
        staff: "Karthik",
        totalMembers: 145,
        subscriptions: 92,
        revenue: 142000,
    },
    {
        staff: "Priya",
        totalMembers: 118,
        subscriptions: 76,
        revenue: 126000,
    },
    {
        staff: "Suresh",
        totalMembers: 96,
        subscriptions: 63,
        revenue: 98000,
    },
    {
        staff: "Divya",
        totalMembers: 84,
        subscriptions: 54,
        revenue: 84000,
    },
];

const initialStats = {
    totalMembers: 420,
    newRegistrations: 84,
    subscriptionMembers: 285,
    totalRevenue: 490000,
    walletBalance: 125000,
    pendingVerification: 48,
};

function Reports() {
    const [reportType, setReportType] = useState("All Reports");
    const [fromDate, setFromDate] = useState("2026-09-01");
    const [toDate, setToDate] = useState("2026-09-30");
    const [status, setStatus] = useState("All Status");

    const maxRegistration = useMemo(() => {
        return Math.max(
            ...memberRegistrationData.map((item) => item.registrations)
        );
    }, []);

    const handleExport = (type) => {
        alert(`${type} report export will be connected to the backend.`);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
        }).format(amount);
    };

    return (
        <div className="branch-reports-page">

            {/* PAGE HEADER */}
            <div className="reports-page-header">
                <div>
                    <div className="reports-title-row">
                        <div className="reports-title-icon">
                            <FileText size={25} />
                        </div>

                        <div>
                            <h1>Reports</h1>
                            <p>
                                View and analyze your branch performance,
                                members and subscriptions
                            </p>
                        </div>
                    </div>
                </div>

                <div className="reports-header-actions">
                    <button
                        className="report-export-btn excel"
                        onClick={() => handleExport("Excel")}
                    >
                        <Download size={17} />
                        Export Excel
                    </button>

                    <button
                        className="report-export-btn pdf"
                        onClick={() => handleExport("PDF")}
                    >
                        <Download size={17} />
                        Export PDF
                    </button>
                </div>
            </div>

            {/* FILTER CARD */}
          {/* FILTER CARD */}
<div className="report-filter-card">

    <div className="report-filter-heading">
        <div className="report-filter-icon">
            <Filter size={19} />
        </div>

        <div>
            <h3>Report Filters</h3>
            <p>Select the date range and report type</p>
        </div>
    </div>

    <div className="report-filter-fields">

        {/* Report Type */}
        <div className="report-field report-type-field">
            <label>Report Type</label>

            <div className="select-wrapper">
                <select
                    value={reportType}
                    onChange={(e) =>
                        setReportType(e.target.value)
                    }
                >
                    <option>All Reports</option>
                    <option>Member Registration</option>
                    <option>Subscription</option>
                    <option>Payment / Wallet</option>
                    <option>Profile Verification</option>
                    <option>Member Performance</option>
                </select>

                <ChevronDown size={16} />
            </div>
        </div>

        {/* From Date */}
        <div className="report-field date-field">
            <label>From Date</label>

            <div className="date-input-wrapper">
                <CalendarDays size={16} />

                <input
                    type="date"
                    value={fromDate}
                    onChange={(e) =>
                        setFromDate(e.target.value)
                    }
                />
            </div>
        </div>

        {/* To Date */}
        <div className="report-field date-field">
            <label>To Date</label>

            <div className="date-input-wrapper">
                <CalendarDays size={16} />

                <input
                    type="date"
                    value={toDate}
                    onChange={(e) =>
                        setToDate(e.target.value)
                    }
                />
            </div>
        </div>

        {/* Status */}
        <div className="report-field status-field">
            <label>Status</label>

            <div className="select-wrapper">
                <select
                    value={status}
                    onChange={(e) =>
                        setStatus(e.target.value)
                    }
                >
                    <option>All Status</option>
                    <option>Active</option>
                    <option>Inactive</option>
                    <option>Pending</option>
                    <option>Verified</option>
                    <option>Rejected</option>
                </select>

                <ChevronDown size={16} />
            </div>
        </div>

        {/* Apply */}
        <div className="report-filter-action">
            <button
                className="apply-report-btn"
                onClick={() =>
                    alert("Report filters applied")
                }
            >
                Apply
            </button>

            <button
                className="reset-report-btn"
                onClick={() => {
                    setReportType("All Reports");
                    setFromDate("2026-09-01");
                    setToDate("2026-09-30");
                    setStatus("All Status");
                }}
            >
                Reset
            </button>
        </div>

    </div>

</div>

            {/* SUMMARY CARDS */}
            <div className="report-summary-grid">

                <div className="report-summary-card blue">
                    <div className="summary-card-content">
                        <span>Total Members</span>
                        <h2>{initialStats.totalMembers}</h2>
                        <small>
                            <TrendingUp size={13} />
                            12.5% from last month
                        </small>
                    </div>

                    <div className="summary-card-icon">
                        <Users size={23} />
                    </div>
                </div>

                <div className="report-summary-card pink">
                    <div className="summary-card-content">
                        <span>New Registrations</span>
                        <h2>{initialStats.newRegistrations}</h2>
                        <small>
                            <UserPlus size={13} />
                            This month
                        </small>
                    </div>

                    <div className="summary-card-icon">
                        <UserPlus size={23} />
                    </div>
                </div>

                <div className="report-summary-card purple">
                    <div className="summary-card-content">
                        <span>Subscription Members</span>
                        <h2>{initialStats.subscriptionMembers}</h2>
                        <small>
                            67.8% of total members
                        </small>
                    </div>

                    <div className="summary-card-icon">
                        <CreditCard size={23} />
                    </div>
                </div>

                <div className="report-summary-card green">
                    <div className="summary-card-content">
                        <span>Total Revenue</span>
                        <h2>
                            {formatCurrency(initialStats.totalRevenue)}
                        </h2>
                        <small>
                            <TrendingUp size={13} />
                            14.8% growth
                        </small>
                    </div>

                    <div className="summary-card-icon">
                        <Wallet size={23} />
                    </div>
                </div>

                <div className="report-summary-card orange">
                    <div className="summary-card-content">
                        <span>Wallet Balance</span>
                        <h2>
                            {formatCurrency(initialStats.walletBalance)}
                        </h2>
                        <small>
                            Available balance
                        </small>
                    </div>

                    <div className="summary-card-icon">
                        <Wallet size={23} />
                    </div>
                </div>

                <div className="report-summary-card red">
                    <div className="summary-card-content">
                        <span>Pending Verification</span>
                        <h2>{initialStats.pendingVerification}</h2>
                        <small>
                            Requires attention
                        </small>
                    </div>

                    <div className="summary-card-icon">
                        <ShieldCheck size={23} />
                    </div>
                </div>

            </div>

            {/* MEMBER REGISTRATION */}
            <section className="report-section-card">

                <div className="section-card-header">
                    <div>
                        <h3>Member Registration Overview</h3>
                        <p>
                            Monthly member registration performance
                        </p>
                    </div>

                    <span className="section-badge">
                        {initialStats.newRegistrations} New
                    </span>
                </div>

                <div className="registration-chart">

                    {memberRegistrationData.map((item) => {
                        const height =
                            (item.registrations / maxRegistration) * 100;

                        return (
                            <div
                                className="chart-column"
                                key={item.month}
                            >
                                <div className="chart-value">
                                    {item.registrations}
                                </div>

                                <div className="chart-bar-area">
                                    <div
                                        className="chart-bar"
                                        style={{
                                            height: `${height}%`,
                                        }}
                                    />
                                </div>

                                <span>{item.month}</span>
                            </div>
                        );
                    })}

                </div>
            </section>

            {/* SUBSCRIPTION + PAYMENT */}
            <div className="reports-two-column">

                {/* SUBSCRIPTION */}
                <section className="report-section-card">

                    <div className="section-card-header">
                        <div>
                            <h3>Subscription Overview</h3>
                            <p>
                                Plan-wise subscription performance
                            </p>
                        </div>
                    </div>

                    <div className="subscription-list">

                        {subscriptionData.map((item) => (
                            <div
                                className="subscription-row"
                                key={item.plan}
                            >
                                <div className="subscription-info">
                                    <div
                                        className={`plan-dot ${item.plan.toLowerCase()}`}
                                    />

                                    <div>
                                        <strong>{item.plan}</strong>
                                        <span>
                                            {item.members} members
                                        </span>
                                    </div>
                                </div>

                                <div className="subscription-progress-wrapper">
                                    <div className="subscription-progress">
                                        <div
                                            className={`subscription-progress-fill ${item.plan.toLowerCase()}`}
                                            style={{
                                                width: `${item.percentage}%`,
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="subscription-amount">
                                    {formatCurrency(item.revenue)}
                                </div>
                            </div>
                        ))}

                    </div>
                </section>

                {/* PAYMENT */}
                <section className="report-section-card">

                    <div className="section-card-header">
                        <div>
                            <h3>Payment & Wallet Overview</h3>
                            <p>
                                Payment method performance
                            </p>
                        </div>
                    </div>

                    <div className="payment-table-wrapper">
                        <table className="report-table">
                            <thead>
                                <tr>
                                    <th>Payment Method</th>
                                    <th>Transactions</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>

                            <tbody>
                                {paymentData.map((item) => (
                                    <tr key={item.method}>
                                        <td>
                                            <strong>
                                                {item.method}
                                            </strong>
                                        </td>

                                        <td>
                                            {item.transactions}
                                        </td>

                                        <td className="amount-cell">
                                            {formatCurrency(
                                                item.amount
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </section>

            </div>

            {/* PROFILE VERIFICATION */}
            <section className="report-section-card">

                <div className="section-card-header">
                    <div>
                        <h3>Profile Verification Overview</h3>
                        <p>
                            Current profile verification status
                        </p>
                    </div>
                </div>

                <div className="verification-grid">

                    {verificationData.map((item) => (
                        <div
                            className={`verification-card ${item.status.toLowerCase()}`}
                            key={item.status}
                        >
                            <div className="verification-icon">
                                <ShieldCheck size={22} />
                            </div>

                            <div>
                                <span>{item.status}</span>
                                <h3>{item.count}</h3>
                                <p>Profiles</p>
                            </div>
                        </div>
                    ))}

                </div>

                <div className="verification-progress">

                    <div className="verification-progress-header">
                        <span>Verification Completion</span>
                        <strong>82.6%</strong>
                    </div>

                    <div className="progress-track">
                        <div
                            className="progress-fill"
                            style={{ width: "82.6%" }}
                        />
                    </div>

                </div>

            </section>
           

        </div>
    );
}

export default Reports;